/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shield': {
    width: 16,
    height: 16,
    viewBox: '0 0 428.16 428.16',
    data: '<path pid="0" d="M393.8 110.208c-.512-11.264-.512-22.016-.512-32.768 0-8.704-6.656-15.36-15.36-15.36-64 0-112.64-18.432-153.088-57.856-6.144-5.632-15.36-5.632-21.504 0C162.888 43.648 114.248 62.08 50.248 62.08c-8.704 0-15.36 6.656-15.36 15.36 0 10.752 0 21.504-.512 32.768-2.048 107.52-5.12 254.976 174.592 316.928l5.12 1.024 5.12-1.024c179.2-61.952 176.64-208.896 174.592-316.928zM201.8 259.2c-3.072 2.56-6.656 4.096-10.752 4.096h-.512c-4.096 0-8.192-2.048-10.752-5.12l-47.616-52.736 23.04-20.48 37.376 41.472 82.944-78.848 20.992 22.528L201.8 259.2z"/>'
  }
})
